import react from '../../assets/Skills/reactjs.svg';
import c from '../../assets/Skills/c_logo.svg';
import express from '../../assets/Skills/expressjs.svg';
import git from '../../assets/Skills/git.svg';
import github from '../../assets/Skills/github.svg';
import java from '../../assets/Skills/java.svg';
import materilaUi from '../../assets/Skills/materialUi.svg';
import mongodb from '../../assets/Skills/mongodb.svg';
import nodejs from '../../assets/Skills/nodejs.svg';
import python from '../../assets/Skills/python.svg';
import reacthookform from '../../assets/Skills/react_hook_form.svg';
import reactnative from '../../assets/Skills/reactnative.svg';
import spfx from '../../assets/Skills/sharepoint.svg';
import tailwindcss from '../../assets/Skills/tailwindcss.svg';

export const skills = [{
    name: "React",
    src: react,
    searchName: "react"
}, {
    name: "C",
    src: c,
    searchName: "c"
}, {
    name: "Express",
    src: express,
    searchName: "express"
}, {
    name: "Git",
    src: git,
    searchName: "git"
}, {
    name: "GitHub",
    src: github,
    searchName: "github"
}, {
    name: "Java",
    src: java,
    searchName: 'java'
}, {
    name: "Material UI",
    src: materilaUi,
    searchName: "materialui"
}, {
    name: "MongoDB",
    src: mongodb,
    searchName: 'mongo'
}, {
    name: "Node JS",
    src: nodejs,
    searchName: 'node'
}, {
    name: "Python",
    src: python,
    searchName: 'python'
}, {
    name: "React Hook Form",
    src: reacthookform,
    searchName: "reacthookform"
}, {
    name: "React Native",
    src: reactnative,
    searchName: 'reactnative'
}, {
    name: "SPFX",
    src: spfx,
    searchName: 'spfx'
}, {
    name: "Tailwind CSS",
    src: tailwindcss,
    searchName: "tailwindcss"
}
];